import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { ContentHeaderComponent } from '../content-header/content-header.component';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    imports: [ContentHeaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelComponent  {
  @Input({ alias: 'background' }) bg: 'faded' | 'transparent' | undefined = undefined;
  @Input() large: boolean = false;
  @Input() padded: boolean = true;
  @Input() spacer: boolean = true;
  @Input() contentHeader: string  | undefined = '';
  @Input() action: string | undefined = '';
  @Input() headerSize: "small" | "medium" | "large" = "medium";
  
  public actionClick = output<void>();

  actionClicked() {
    this.actionClick.emit();
  }
}